'use client'

import dynamic from 'next/dynamic'
import { useRecoilState } from 'recoil'
import LazyMount from '@/components/common/LazyMount'
import useI18n from 'Hooks/useI18n'
import { loginModalOpenState } from 'Store/login'

const LoginModal = dynamic(() => import('./LoginModal'), { ssr: false })

type LoginProps = {
  showTrigger?: boolean
  zIndex?: number
}

export default function Login({
  showTrigger = true,
  zIndex = 2000,
}: LoginProps) {
  const { t } = useI18n()
  const [open, setOpen] = useRecoilState(loginModalOpenState)

  return (
    <>
      {showTrigger ? (
        <div
          className="pointer-events-auto flex h-9 cursor-pointer items-center rounded-full border border-secondary-border bg-white/20 px-4 py-1 text-sm transition hover:border-hover-border"
          onClick={() => setOpen(true)}
          onKeyDown={(event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return
            event.preventDefault()
            setOpen(true)
          }}
          role="button"
          tabIndex={0}
        >
          {t('Login')}
        </div>
      ) : null}
      <LazyMount open={open}>
        <LoginModal open={open} setOpen={setOpen} zIndex={zIndex} />
      </LazyMount>
    </>
  )
}
